import { Field, Label, ErrorMessage } from "V2.0/common/fieldset";
import { Textarea } from "V2.0/common/textarea";
import { Input } from "V2.0/common/input";
import { Listbox, ListboxOption, ListboxLabel } from "V2.0/common/listbox";
import { Switch } from "V2.0/common/switch";
import { DelayMode, delayModeConfig } from "../../Models/Delay";

export default DelayForm;

function DelayForm(props) {
  const { formState, updateFormState, errors } = props;

  return (
    <div className="space-y-8">
      <Field>
        <Label>Name *</Label>
        <Input
          type="text"
          value={formState.name}
          invalid={!!errors.name}
          onChange={(e) => updateFormState("name", e.target.value)}
        />
        {errors.name && <ErrorMessage>{errors.name}</ErrorMessage>}
      </Field>

      <Field>
        <Label>Description</Label>
        <Textarea
          rows={3}
          style={{ fontSize: "13px" }}
          value={formState.description}
          onChange={(e) => updateFormState("description", e.target.value)}
        />
      </Field>

      <Field>
        <Label>Mode *</Label>
        <Listbox
          as="div"
          className="my-4"
          value={formState.delayMode}
          defaultValue={formState.delayMode}
          onChange={(value) => updateFormState("delayMode", value)}
        >
          {Object.values(delayModeConfig).map((delayMode) => {
            return (
              <ListboxOption
                key={delayMode.value}
                value={delayMode.value}
              >
                <ListboxLabel>{delayMode.label}</ListboxLabel>
              </ListboxOption>
            );
          })}
        </Listbox>
      </Field>

      {formState.delayMode === DelayMode.FIXED && (
        <Field>
          <Label>Delay (seconds) *</Label>
          <Input
            type="number"
            value={formState.delaySeconds}
            min={0}
            onChange={(e) =>
              updateFormState("delaySeconds", Number(e.target.value))
            }
          />
        </Field>
      )}

      {formState.delayMode !== DelayMode.FIXED && (
        <Field>
          <Label>Delay Expression *</Label>
          <Textarea
            rows={3}
            value={formState.delayExpression}
            onChange={(e) => updateFormState("delayExpression", e.target.value)}
            style={{ fontSize: "13px" }}
          />
          {errors.delayExpression && (
            <ErrorMessage>{errors.delayExpression}</ErrorMessage>
          )}
        </Field>
      )}

      {formState.delayMode !== DelayMode.FIXED && (
        <Field>
          <Label>Offset (seconds)</Label>
          <Input
            type="number"
            placeholder="-10800"
            value={formState.offsetSeconds}
            onChange={(e) =>
              updateFormState("offsetSeconds", Number(e.target.value))
            }
          />
        </Field>
      )}

      {formState.delayMode !== DelayMode.FIXED && (
        <Field>
          <Label>Minimum Delay (seconds)</Label>
          <Input
            type="number"
            placeholder={0}
            value={formState.minimumDelaySeconds}
            min={0}
            onChange={(e) =>
              updateFormState("minimumDelaySeconds", e.target.value)
            }
          />
        </Field>
      )}

      {formState.delayMode === DelayMode.UNTIL_TIMESTAMP && (
        <Field className="flex items-end space-x-2">
          <Label>Skip If Past</Label>
          <Switch
            checked={formState.skipIfPast}
            color="emerald"
            onChange={() =>
              updateFormState("skipIfPast", !formState.skipIfPast)
            }
          />
        </Field>
      )}
    </div>
  );
}
